<template>
  <div class="configDiagram">
      <div class="configMap">
        <div class='alarm_box' v-if='alarm_list.length>0'>
      <!-- <div class='alarm_box' v-if='false' > -->
<!--      <alarmBox @deal='is_receive' :alarmContent='alarm_list' @showDeatil='alarmDetail'></alarmBox>-->
     </div>
      </div>


  </div>
</template>
<script>
  import alarmBox from '../alarm/alarm_box.vue';
  import dialogItem from "../../../components/dialog/dialogs";
  import xunjianMap from "./baseMap/xunjian_map";
   export default {
     props: {
      searchData: {
        type: Array,
        default: () => {
          return []
        }
      },
      isStatus: {
        type: Boolean,
        default: () => {
          return false
        }
      },
      lineType:{
        type: String,
        default: () => {
          return ''
        }
      },
    },
    data(){
      return{
        //弹框详情dialog
        showDialog: false,
        params: {},
        detail: {
          alarmDetailData: {},
          deviceData: {},
          mesData: {},
          presData: {}
        },
        //地图数据
        alarm_list: [], //报警列表数据
        clearMesInterval: null,  //警报声的定时器
        onlineNum: 0,   //今日实时在线个数
        header_search: [],  //




        // 同步数据记录点击次数，默认为0
        i:0,
        showMoreData:false,
        labelHeight:44,
        check_type:0,
        cluster: [],
        markers: [],
        chinApp:{},
      }
    },
    components:{
      alarmBox,
      dialogItem,

    },
    mounted(){
      this.onWindowResize()
      window.addEventListener('resize', this.onWindowResize)

    },
    methods:{
      //页面自适应
      onWindowResize () {
        let pageHeight = document.documentElement.clientHeight //页面总高度
        if (document.querySelectorAll('.configMap') && document.querySelectorAll('.configMap')[0]) {
          document.querySelectorAll('.configMap')[0].style.height = pageHeight - 265 + 'px'  //在这里可以根据你的边距做调整
        }
      }
    },

  }

</script>
<style lang="less" scoped>
  .configDiagram {
    padding: 0px 5px 0px 5px;
    width: 100%;
    height: 100%;
    position: relative;
     .configMap {
      border: 4px solid #0a3263;
       background: url(../../../../static/img/ldgwdgc.jpg);



    }
    .alarm_box{
      width:614px;
      height: 314px;
      opacity: 0.5;
      position: fixed;
      top:50%;
      left:50%;
      margin:-157px 0 0 -307px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/configDiagram.vue